import { Estimate } from "types/Estimate";

import client from "./client";

interface EstimateResponse {
  estimate: Estimate;
}

export const getEstimate = (sessionId: string, clientId: string, enablePayeeJourney?: boolean): Promise<EstimateResponse> =>
  client.get(`/client/${clientId}/session/${sessionId}/estimate`, {
    params: {
      ...(enablePayeeJourney ? { enablePayeeJourney } : {}),
    }
  }).then(({ data }) => data);
